import { StyledParagraph } from '@components/Text';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { HeadingColor, ImgWH, ImgWidth100, LabelColor, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import os from '@src/lang/ko/main/os/os';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card, CardDesc, CardLayout, CardOverlay, ToggleBtn } from '../../Os.style';
import { DivAllCenter, DivFlexColumn, DivPadding } from '@pages/CommonStyle/commonDiv.style';
import { HeadingH3, HeadingH3white } from '@components/Text/Heading/Heading.style';
import { Link } from 'react-router-dom';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import simple from '@src/lang/ko/simple';
import i18n from '@pages/i18n';
import { IconShowDescOff, IconShowDescOn } from '@assets/images/main/icon';
import { StyledShowMore } from '@pages/Enterprise/Blog/Main/BlogModule.style';
import { IconChevronRight } from '@assets/images/icon';
import { ShowMore } from './HeadSection.style';
import { SectionDefaultLayout } from './SectionDefault.style';
import { StyledGridContainer } from '@components/Grid/Grid.style';

export const SpaceBar = () => <>&nbsp;</>;

const SectionDefault = ({ section, layoutType }) => {
  const [layoutMaxWidth, setLayoutMaxWidth] = useState<any>(null);

  useEffect(() => {
    const handleResize = () => {
      setLayoutMaxWidth(window.innerWidth);
    };
    setLayoutMaxWidth(document.documentElement.clientWidth);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <SectionDefaultLayout>
        <StyledGridContainer>
          <DivAllCenter>
            <SpacingDTM d={'256'} t={'128'} m={'96'} />
            <HeadingColor color={'#818181'} size={'xxxsmall'}>
              <Trans i18nKey={`os.${section}.tag`} />
            </HeadingColor>
            <Spacing pixel="8" />
            <DisplayH2 size={'small'}>
              <Trans i18nKey={`os.${section}.title`} />
            </DisplayH2>
            <Spacing pixel="16" />
            <StyledParagraph size={'medium'}>
              <p>
                <Trans i18nKey={`os.${section}.desc`} components={{ br: layoutType === 'mobile' ? <SpaceBar /> : <br /> }} />
              </p>
            </StyledParagraph>
          </DivAllCenter>

          <SpacingDTM d={'64'} t={'64'} m={'48'} />

          <CardLayout>
            {os[section].box.map((data, i) => {
              return (
                <>
                  <Card w={layoutMaxWidth} img={data.img[layoutType]} index={data.size} bgColor={'#fff'}>
                    {
                      <>
                        <CardDesc gap="32">
                          <DivAllCenter>
                            <HeadingH3 size={layoutType === 'mobile' ? 'xsmall' : 'small'}>
                              <Trans i18nKey={`os.${section}.box.${i}.title`} />
                            </HeadingH3>
                            <Spacing pixel="4" />
                            <ParagraphColor size={'small'} color={'#818181'}>
                              <Trans i18nKey={`os.${section}.box.${i}.desc`} />
                            </ParagraphColor>
                            <Spacing pixel="16" />

                            <Link to={i18n.language === 'ko' ? `${data.link}` : `/${i18n.language}${data.link}`}>
                              <ShowMore onClick={SpaceBar}>
                                <LabelColor size="medium" color="#2A70F0">
                                  <Trans i18nKey={`home.showMore`} />{' '}
                                </LabelColor>
                                <DivPadding a={'0'} b={'0'} c={'0'} d={'4'} />
                                <ImgWH src={IconChevronRight} alt="Right Arrow Icon" w={'20'} h={'20'} />
                              </ShowMore>
                            </Link>
                          </DivAllCenter>
                        </CardDesc>
                      </>
                    }
                  </Card>
                </>
              );
            })}
          </CardLayout>
        </StyledGridContainer>
      </SectionDefaultLayout>
    </>
  );
};

export default SectionDefault;
